export default __webpack_public_path__ + "static/media/smileLogo.c7fd5715.png";